import React from 'react'

import styled from 'styled-components'

export const Quote = ({
  children,
  author,
}: {
  children: string | JSX.Element
  author?: string
}) => {
  if (!children) return null
  return (
      <_Quote className='quote'>
        <p>{children}</p>
        <span>{author && author}</span>
      </_Quote>
 
  )
}

const _Quote = styled.blockquote`
  font-size: 10px;
  width: 90%;

  font-weight: 900;
  margin: 0;
  padding-top: 30px;
  margin-bottom: 60px;
  box-sizing: border-box;
  @media (min-width: 712px) {
    grid-column: 3 / span 4;
  }
  @media (min-width: 1072px) {
    grid-column: 4 / span 6;
  }

  &::before,
  &::after {
    content: '';
    display: block;
    width: 6rem;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2rem;
    margin-bottom: 2rem;
    border-top: 1px solid #9698a8;
  }
  &::after {
    margin-top: 1.8rem;
    margin-bottom: 2rem;
  }
  p {
    margin-top: 0em !important;
    margin-bottom: 0.15em !important;
    text-align: center;
    font-size: 30px !important;
    line-height: 38px !important;
  }
  span {
    margin-bottom: 2em !important;
    color: rgb(125, 125, 125);
    font-family: var(--chart-font-stack);
    font-weight: 400;
    display: inline-block;
    width: 100%;
    text-align: center;
    line-height: 1.6em;
    font-size: 1.5em;
  }
  margin-left: 5%;
  margin-right: 5%;
`
